import { useAsyncData } from '~/core/shared/api/asyncData';
import { EMPTY_OBJ } from '~/core/shared/constants';
import { WorkflowDefaultStepBlock } from '~/core/shared/types';
import { isFormFieldBlockWithAsyncComponentProps } from './logic/isFormFieldBlockWithAsyncComponentProps';

export function useAsyncProps(block: WorkflowDefaultStepBlock) {
  const hasAsyncProps = isFormFieldBlockWithAsyncComponentProps(block);
  const config = hasAsyncProps
    ? block.asyncComponentProps.asyncData
    : undefined;

  const { asyncDataAsProps, isLoading } = useAsyncData(config);

  return {
    asyncProps: hasAsyncProps ? asyncDataAsProps : EMPTY_OBJ,
    isLoadingAsyncProps: hasAsyncProps && isLoading,
  };
}
